import script from "./CadernoTurmaView.vue?vue&type=script&setup=true&lang=js"
export * from "./CadernoTurmaView.vue?vue&type=script&setup=true&lang=js"

import "./CadernoTurmaView.vue?vue&type=style&index=0&id=224d7ba8&lang=css"

const __exports__ = script;

export default __exports__